export default "__VITE_ASSET__DYcnoGrJ__"